import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useI18n } from '@/i18n/I18nProvider';
import { BuildingIcon } from '@/components/icons';

const PLACEHOLDER = '-';

function InfoField({ label, value, span = 1 }: { label: string; value?: React.ReactNode; span?: 1 | 2 }) {
  return (
    <div className={`space-y-2 ${span === 2 ? 'md:col-span-2' : ''}`}>
      <div className="block text-sm font-medium text-foreground mb-1">{label}</div>
      <div className="bg-muted rounded px-3 py-2 text-sm">{value ?? PLACEHOLDER}</div>
    </div>
  );
}

interface SchoolInfoCardProps {
  schoolName?: string | null;
  schoolYear?: string | null;
  schoolAddress?: string | null;
  schoolPhone?: string | null;
  schoolEmail?: string | null;
}

export function SchoolInfoCard({
  schoolName,
  schoolYear,
  schoolAddress,
  schoolPhone,
  schoolEmail,
}: SchoolInfoCardProps) {
  const { t } = useI18n();

  return (
    <Card className="border shadow-sm">
      <CardHeader className="rounded-t-xl bg-primary text-primary-foreground">
        <CardTitle className="text-lg flex items-center">
          <BuildingIcon className="me-2" />
          {t.parentConduct.schoolSection.title}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <InfoField label={t.parentConduct.schoolSection.schoolName} value={schoolName || PLACEHOLDER} />
          <InfoField label={t.parentConduct.schoolSection.schoolYear} value={schoolYear || PLACEHOLDER} />
          <InfoField label={t.parentConduct.schoolSection.address} value={schoolAddress || PLACEHOLDER} span={2} />
          <InfoField label={t.parentConduct.schoolSection.phone} value={schoolPhone || PLACEHOLDER} />
          <InfoField label={t.parentConduct.schoolSection.email} value={schoolEmail || PLACEHOLDER} />
        </div>
      </CardContent>
    </Card>
  );
}
